import React from "react";
import styles from "./Footer.module.scss";

interface SocialMediaIconProps {
  platform: 'x' | 'youtube' | 'linkedin';
  href: string;
  ariaLabel: string;
  className?: string;
}

const SocialMediaIcon: React.FC<SocialMediaIconProps> = ({ 
  platform, 
  href, 
  ariaLabel, 
  className 
}) => {
  const getIconSvg = () => {
    switch (platform) {
      case 'x':
        return (
          <path d="M16.6643 11.849L27.0879 -0.000976562H24.6179L15.567 10.2882L8.33814 -0.000976562H0.000488281L10.932 15.5581L0.000488281 27.9847H2.4707L12.0286 17.1189L19.6628 27.9847H28.0005L16.6637 11.849H16.6643ZM13.281 15.6952L12.1734 14.1458L3.36075 1.81764H7.15484L14.2668 11.7669L15.3744 13.3162L24.619 26.2487H20.8249L13.281 15.6958V15.6952Z" />
        );
      case 'youtube':
        return (
          <path fillRule="evenodd" clipRule="evenodd" d="M30.4036 7.89995C25.5011 7.54381 18.0753 7.54381 18 7.54381V7.56689H17.9902C17.9182 7.56689 10.4989 7.57019 5.58982 7.92303L5.37382 7.94281L5.35924 7.94424C4.72464 8.00651 4.00709 8.07691 3.31855 8.79359C2.99782 9.11675 2.61818 10.2841 2.49055 11.125C2.28415 12.9545 2.1749 14.7939 2.16327 16.6352V19.326C2.17441 21.1673 2.28366 23.0067 2.49055 24.8362C2.61491 25.6672 2.988 26.8313 3.31527 27.161C3.924 27.7975 4.77164 27.8997 5.51782 27.9887C5.70764 28.0085 5.868 28.0316 6.03491 28.058C8.83964 28.2987 17.6269 28.3877 18.0033 28.3877C18.3305 28.3877 25.5862 28.3547 30.4036 28.025L30.6262 28.0019L30.6313 28.0014C31.2682 27.9389 31.9895 27.8681 32.6782 27.1511C32.9989 26.8412 33.3818 25.6573 33.5029 24.8428C33.7094 23.0122 33.8186 21.1717 33.8302 19.3293V16.6121C33.819 14.7708 33.7098 12.9314 33.5029 11.1019C33.3753 10.2676 33.0022 9.10026 32.6749 8.7705C31.9811 8.04834 31.2742 7.97909 30.6196 7.91973L30.4036 7.89995ZM5.40655 5.78621C10.4433 5.42347 18 5.42347 18 5.42347V5.40039C18 5.40039 25.5633 5.40039 30.6098 5.76642C30.6751 5.77383 30.7477 5.78063 30.8268 5.78805C31.5929 5.85981 32.9699 5.98883 34.2098 7.28C35.2898 8.3682 35.64 10.8381 35.64 10.8381C35.8642 12.7636 35.9844 14.6999 36 16.6385V19.3557C35.9822 21.2944 35.8598 23.2308 35.6335 25.1561C35.6335 25.1561 35.28 27.626 34.2033 28.7109C32.973 29.9982 31.601 30.1303 30.8289 30.2046C30.7465 30.2126 30.6711 30.2198 30.6033 30.2278C25.5633 30.6004 18 30.6004 18 30.6004C18 30.6004 8.64 30.5147 5.76 30.241C5.62212 30.2149 5.45483 30.1945 5.26534 30.1715C4.35285 30.0606 2.92566 29.8872 1.79018 28.7076C0.710182 27.6227 0.36 25.1528 0.36 25.1528C0.135753 23.2273 0.0155752 21.291 0 19.3524V16.6352C0.0218737 14.704 0.147512 12.7754 0.376363 10.8579C0.376363 10.8579 0.729818 8.38798 1.80655 7.29979C3.0381 6.01425 4.40559 5.88343 5.17784 5.80956C5.26134 5.80157 5.33788 5.79425 5.40655 5.78621ZM23.9994 17.9996L14.3994 23.3996V12.5996L23.9994 17.9996Z" />
        );
      case 'linkedin':
        return (
          <>
            <path d="M16.527 19.7638H19.649V13.3579C19.649 10.155 17.6978 9.08732 15.8441 9.08732C14.1856 9.08732 13.0148 10.155 12.7222 10.8344V9.3785H9.60022V19.7638H12.9173V14.2314C12.9173 12.7756 13.8929 11.9991 14.8685 11.9991C15.8441 11.9991 16.527 12.4844 16.527 14.1344V19.7638Z" />
            <path d="M4.42949 9.3785V19.7638H7.74657V9.3785H4.42949Z" />
            <path d="M4.23438 6.07849C4.23438 7.14614 5.01486 7.92261 6.08803 7.92261C7.16119 7.92261 7.94169 7.14614 7.94169 6.07849C7.94169 5.01085 7.16119 4.23438 6.08803 4.23438C5.11242 4.23438 4.23438 5.01085 4.23438 6.07849Z" />
          </>
        );
      default:
        return null;
    }
  };

  const getViewBox = () => {
    switch (platform) {
      case 'x':
        return "0 0 28 28";
      case 'youtube':
        return "0 0 36 36";
      case 'linkedin':
        return "0 0 24 24";
      default:
        return "0 0 24 24";
    }
  };

  const iconClass = `${styles["u-icon"]} ${styles[`u-icon--${platform}`]}`;

  return (
    <a 
      href={href} 
      className={`${styles["c-button"]} ${styles["c-button--social"]} ${className || ""}`}
      target="_blank" 
      rel="noopener noreferrer"
      aria-label={ariaLabel}
    >
      <div>
        <span>
          <svg className={iconClass} viewBox={getViewBox()} xmlns="http://www.w3.org/2000/svg">
            {getIconSvg()}
          </svg>
        </span>
        <span aria-hidden="true">
          <svg className={iconClass} viewBox={getViewBox()} xmlns="http://www.w3.org/2000/svg">
            {getIconSvg()}
          </svg>
        </span>
      </div>
    </a>
  );
};

export default SocialMediaIcon; 